module.exports = __webpack_public_path__ + "img/album17_23.8851136a.jpg";